
function useSettings(){

    const settings = JSON.parse(localStorage.getItem("settings"));

    if(settings === undefined || settings === null){
        return({status:false});
    }else{
        if(settings?.id !== ""){
            return({status:true, settings: {...settings}})
        }else{
            return({status:false});
        }
    }
}


export default useSettings;